import cn from 'classnames';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import { Panel } from '@creditflowresearch/uilib/PanelGroup';
import Tranche from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Tranche';
import Header from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Header';
import type ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/TranchePanel/tranchePanel.module.scss';
import headerStyles from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Header/header.module.scss';

export const TranchePanel = ({ index, tranche }: { index: number, tranche: ITranch }) => {
  return (
    <Panel
      key={ tranche.id }
      id={ tranche.id }
      dataTest={ `tranchePanel-${ tranche.id }` }
      className={ styles.tranchePanel }
      headerClass={ cn(headerStyles.header, { [headerStyles.dropped]: tranche.droppedTranche }) }
      arrowWrapperClass={ headerStyles.arrow }
      contentClass={ styles.content }
      header={ <Header tranche={ tranche } index={ index } /> }
      arrow={ <IconExpand /> }
      arrowActive={ <IconCollapse /> }
    >
      <Tranche tranche={ tranche } />
    </Panel>
  );
};
